import { Component, Input } from '@angular/core';
import { LocDisclosureInfo } from '../../apr-calculator.model';

@Component({
    selector: 'ifa-apr-disclosure-ca-loc',
    templateUrl: './apr-disclosure-ca-loc.component.html',
    styleUrls: ['../../apr-disclosure.component.scss', './apr-disclosure-ca-loc.component.scss'],
    standalone: false
})
export class AprDisclosureCaLocComponent {

    @Input() data: LocDisclosureInfo = new LocDisclosureInfo('', 0, 0, null, null, 0, 0, 0, 0);
}